import { Component, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";

@Component({
	selector: "app-snow",
	standalone: true,
	template: `
		<div class="snow-container">
			@for (i of flakes; track i) {
				<span class="snow">&#10052;</span>
			}
		</div>
	`,
	styleUrls: ["./snow.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	encapsulation: ViewEncapsulation.None,
})
export class SnowComponent {
	flakes = Array.from({ length: 50 }, (_, i) => i);
}
